"use client";

import React, { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setSubmitted(true);
  };
  return <section id="newslettersignup" data-nav="dark" className="relative w-full py-[60px] px-5 bg-[linear-gradient(135deg,#001a4d,#003d99)] text-white overflow-hidden">
      <div className="mx-auto max-w-[600px] text-center">
        {/* Bilingual Heading */}
        <h2 className="text-[26px] sm:text-[28px] font-bold text-[#d4af37] leading-tight tracking-[0.5px]">
          <span className="block mb-1" dir="rtl">
            اشترك في نشرتنا الإخبارية
          </span>
          <span className="block font-semibold">
            Subscribe to Our Newsletter
          </span>
        </h2>

        {/* Subtitle */}
        <p className="mt-3.5 mb-8 text-[15px] sm:text-[16px] text-white/90 leading-relaxed">
          احصل على أفضل عروض B2B يومياً | Get Daily B2B Electronics Deals
        </p>

        {/* Interactive Form or Confirmation */}
        {submitted ? <div role="status" aria-live="polite" className="rounded-xl border-2 border-[#d4af37] bg-white/10 backdrop-blur-xs p-6 shadow-md">
            <div className="mx-auto mb-3 flex size-12 items-center justify-center rounded-full bg-[#d4af37] text-[#001a4d]">
              <Check className="size-6 stroke-[3]" />
            </div>
            <p className="mb-0 text-lg font-bold text-[#d4af37]">
              شكراً! تحقق من بريدك | Thank you! Check your email
            </p>
          </div> : <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center" noValidate>
            <div className="flex-1">
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="البريد الإلكتروني | Email Address" aria-label="Email address" className="h-11 w-full rounded-lg border-2 border-[#d4af37] bg-white px-4 py-2 text-base text-[#001a4d] placeholder:text-[#001a4d]/60 shadow-xs outline-none transition-colors focus:ring-2 focus:ring-[#d4af37] focus:ring-offset-2 focus:ring-offset-[#001a4d]" />
            </div>
            <Button type="submit" className="h-11 shrink-0 rounded-lg bg-[#d4af37] px-6 text-sm font-bold text-[#001a4d] shadow-sm transition-all duration-300 hover:scale-[1.02] hover:bg-[#e6c352] hover:shadow-md active:scale-[0.98]">
              اشترك الآن | Subscribe Now
            </Button>
          </form>}

        {error && <p className="mt-2 text-sm text-red-300 font-medium">{error}</p>}

        {/* Reassurance text */}
        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-white/80">
          <span className="inline-flex items-center gap-1.5">
            <span className="text-[#d4af37] font-bold"></span>
            <span>لا توجد رسائل بريدية مزعجة | No spam emails</span>
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="text-[#d4af37] font-bold"></span>
            <span>إلغاء الاشتراك في أي وقت | Unsubscribe anytime</span>
          </span>
        </div>
      </div>
    </section>;
}